// Villes ayant leur propre page SEO complète (`/carton-demenagement-:slug`).
// On y ajoute une ville à la fois avec son `templateId` dédié.

const CITY_PAGES = [
  {
    slug: "boulogne-billancourt",
    name: "Boulogne-Billancourt",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "boulogne-billancourt",
    nearbyCities: [
      "Antony",
      "Asnières-sur-Seine",
      "Bagneux",
      "Bois-Colombes",
      "Bourg-la-Reine",
      "Châtenay-Malabry",
    ],
  },
  {
    slug: "neuilly-sur-seine",
    name: "Neuilly-sur-Seine",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "neuilly-sur-seine",
    nearbyCities: [
      "Levallois-Perret",
      "Clichy",
      "Courbevoie",
      "La Garenne-Colombes",
      "Colombes",
      "Gennevilliers",
      "Villeneuve-la-Garenne",
    ],
  },
  {
    slug: "nanterre",
    name: "Nanterre",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "nanterre",
    nearbyCities: [
      "Puteaux",
      "Rueil-Malmaison",
      "Suresnes",
      "Garches",
      "Saint-Cloud",
      "Vaucresson",
    ],
  },
  {
    slug: "montrouge",
    name: "Montrouge",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "montrouge",
    nearbyCities: [
      "Malakoff",
      "Châtillon",
      "Clamart",
      "Fontenay-aux-Roses",
      "Le Plessis-Robinson",
      "Sceaux",
    ],
  },
  {
    slug: "sevres",
    name: "Sèvres",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "sevres",
    nearbyCities: [
      "Meudon",
      "Chaville",
      "Ville-d'Avray",
      "Issy-les-Moulineaux",
      "Marnes-la-Coquette",
      "Vanves",
    ],
  },
  {
    slug: "levallois-perret",
    name: "Levallois-Perret",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "levallois-perret",
    nearbyCities: [
      "Clichy",
      "Courbevoie",
      "La Garenne-Colombes",
      "Neuilly-sur-Seine",
      "Asnières-sur-Seine",
      "Colombes",
    ],
  },
  {
    slug: "clichy",
    name: "Clichy",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "clichy",
    nearbyCities: [
      "Levallois-Perret",
      "Asnières-sur-Seine",
      "Neuilly-sur-Seine",
      "Courbevoie",
      "Gennevilliers",
      "Bois-Colombes",
    ],
  },
  {
    slug: "courbevoie",
    name: "Courbevoie",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "courbevoie",
    nearbyCities: [
      "Puteaux",
      "Levallois-Perret",
      "La Garenne-Colombes",
      "Bois-Colombes",
      "Asnières-sur-Seine",
      "Neuilly-sur-Seine",
    ],
  },
  {
    slug: "la-garenne-colombes",
    name: "La Garenne-Colombes",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "la-garenne-colombes",
    nearbyCities: [
      "Courbevoie",
      "Bois-Colombes",
      "Colombes",
      "Asnières-sur-Seine",
      "Levallois-Perret",
      "Puteaux",
    ],
  },
  {
    slug: "colombes",
    name: "Colombes",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "colombes",
    nearbyCities: [
      "La Garenne-Colombes",
      "Bois-Colombes",
      "Courbevoie",
      "Asnières-sur-Seine",
      "Gennevilliers",
      "Nanterre",
    ],
  },
  {
    slug: "gennevilliers",
    name: "Gennevilliers",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "gennevilliers",
    nearbyCities: [
      "Asnières-sur-Seine",
      "Colombes",
      "Villeneuve-la-Garenne",
      "Bois-Colombes",
      "Courbevoie",
      "Clichy",
    ],
  },
  {
    slug: "villeneuve-la-garenne",
    name: "Villeneuve-la-Garenne",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "villeneuve-la-garenne",
    nearbyCities: [
      "Gennevilliers",
      "Asnières-sur-Seine",
      "Colombes",
      "Bois-Colombes",
      "Courbevoie",
      "Levallois-Perret",
    ],
  },
  {
    slug: "antony",
    name: "Antony",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "antony",
    nearbyCities: [
      "Sceaux",
      "Bourg-la-Reine",
      "Châtenay-Malabry",
      "Fontenay-aux-Roses",
      "Bagneux",
      "Montrouge",
    ],
  },
  {
    slug: "asnieres-sur-seine",
    name: "Asnières-sur-Seine",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "asnieres-sur-seine",
    nearbyCities: [
      "Gennevilliers",
      "Clichy",
      "Bois-Colombes",
      "Colombes",
      "Courbevoie",
      "Levallois-Perret",
    ],
  },
  {
    slug: "bagneux",
    name: "Bagneux",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "bagneux",
    nearbyCities: [
      "Montrouge",
      "Fontenay-aux-Roses",
      "Châtillon",
      "Malakoff",
      "Sceaux",
      "Antony",
    ],
  },
  {
    slug: "bois-colombes",
    name: "Bois-Colombes",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "bois-colombes",
    nearbyCities: [
      "Asnières-sur-Seine",
      "Colombes",
      "Courbevoie",
      "La Garenne-Colombes",
      "Levallois-Perret",
      "Gennevilliers",
    ],
  },
  {
    slug: "bourg-la-reine",
    name: "Bourg-la-Reine",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "bourg-la-reine",
    nearbyCities: [
      "Sceaux",
      "Antony",
      "Bagneux",
      "Châtenay-Malabry",
      "Fontenay-aux-Roses",
      "Montrouge",
    ],
  },
  {
    slug: "chatenay-malabry",
    name: "Châtenay-Malabry",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "chatenay-malabry",
    nearbyCities: [
      "Sceaux",
      "Bourg-la-Reine",
      "Antony",
      "Le Plessis-Robinson",
      "Clamart",
      "Fontenay-aux-Roses",
    ],
  },
  {
    slug: "puteaux",
    name: "Puteaux",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "puteaux",
    nearbyCities: [
      "Courbevoie",
      "Suresnes",
      "Nanterre",
      "Neuilly-sur-Seine",
      "La Garenne-Colombes",
      "Boulogne-Billancourt",
    ],
  },
  {
    slug: "rueil-malmaison",
    name: "Rueil-Malmaison",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "rueil-malmaison",
    nearbyCities: [
      "Suresnes",
      "Nanterre",
      "Puteaux",
      "Saint-Cloud",
      "Garches",
      "Vaucresson",
    ],
  },
  {
    slug: "suresnes",
    name: "Suresnes",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "suresnes",
    nearbyCities: [
      "Puteaux",
      "Rueil-Malmaison",
      "Nanterre",
      "Saint-Cloud",
      "Garches",
      "Neuilly-sur-Seine",
    ],
  },
  {
    slug: "garches",
    name: "Garches",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "garches",
    nearbyCities: [
      "Saint-Cloud",
      "Vaucresson",
      "Marnes-la-Coquette",
      "Rueil-Malmaison",
      "Suresnes",
      "Ville-d'Avray",
    ],
  },
  {
    slug: "saint-cloud",
    name: "Saint-Cloud",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "saint-cloud",
    nearbyCities: [
      "Garches",
      "Suresnes",
      "Sèvres",
      "Boulogne-Billancourt",
      "Rueil-Malmaison",
      "Marnes-la-Coquette",
    ],
  },
  {
    slug: "vaucresson",
    name: "Vaucresson",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "vaucresson",
    nearbyCities: [
      "Garches",
      "Marnes-la-Coquette",
      "Saint-Cloud",
      "Rueil-Malmaison",
      "Ville-d'Avray",
      "Chaville",
    ],
  },
  {
    slug: "malakoff",
    name: "Malakoff",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "malakoff",
    nearbyCities: [
      "Montrouge",
      "Châtillon",
      "Vanves",
      "Clamart",
      "Bagneux",
      "Issy-les-Moulineaux",
    ],
  },
  {
    slug: "chatillon",
    name: "Châtillon",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "chatillon",
    nearbyCities: [
      "Malakoff",
      "Montrouge",
      "Bagneux",
      "Clamart",
      "Fontenay-aux-Roses",
      "Vanves",
    ],
  },
  {
    slug: "clamart",
    name: "Clamart",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "clamart",
    nearbyCities: [
      "Châtillon",
      "Meudon",
      "Issy-les-Moulineaux",
      "Vanves",
      "Fontenay-aux-Roses",
      "Le Plessis-Robinson",
    ],
  },
  {
    slug: "fontenay-aux-roses",
    name: "Fontenay-aux-Roses",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "fontenay-aux-roses",
    nearbyCities: [
      "Sceaux",
      "Bagneux",
      "Clamart",
      "Châtenay-Malabry",
      "Le Plessis-Robinson",
      "Bourg-la-Reine",
    ],
  },
  {
    slug: "le-plessis-robinson",
    name: "Le Plessis-Robinson",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "le-plessis-robinson",
    nearbyCities: [
      "Châtenay-Malabry",
      "Clamart",
      "Fontenay-aux-Roses",
      "Sceaux",
      "Antony",
      "Meudon",
    ],
  },
  {
    slug: "sceaux",
    name: "Sceaux",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "sceaux",
    nearbyCities: [
      "Bourg-la-Reine",
      "Fontenay-aux-Roses",
      "Le Plessis-Robinson",
      "Châtenay-Malabry",
      "Antony",
      "Bagneux",
    ],
  },
  {
    slug: "meudon",
    name: "Meudon",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "meudon",
    nearbyCities: [
      "Sèvres",
      "Clamart",
      "Issy-les-Moulineaux",
      "Chaville",
      "Ville-d'Avray",
      "Le Plessis-Robinson",
    ],
  },
  {
    slug: "chaville",
    name: "Chaville",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "chaville",
    nearbyCities: [
      "Sèvres",
      "Meudon",
      "Ville-d'Avray",
      "Vélizy-Villacoublay",
      "Viroflay",
      "Garches",
    ],
  },
  {
    slug: "ville-davray",
    name: "Ville-d'Avray",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "ville-davray",
    nearbyCities: [
      "Sèvres",
      "Chaville",
      "Saint-Cloud",
      "Garches",
      "Marnes-la-Coquette",
      "Vaucresson",
    ],
  },
  {
    slug: "issy-les-moulineaux",
    name: "Issy-les-Moulineaux",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "issy-les-moulineaux",
    nearbyCities: [
      "Boulogne-Billancourt",
      "Vanves",
      "Meudon",
      "Clamart",
      "Malakoff",
      "Paris 15ᵉ",
    ],
  },
  {
    slug: "marnes-la-coquette",
    name: "Marnes-la-Coquette",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "marnes-la-coquette",
    nearbyCities: [
      "Vaucresson",
      "Garches",
      "Saint-Cloud",
      "Ville-d'Avray",
      "Chaville",
      "Sèvres",
    ],
  },
  {
    slug: "vanves",
    name: "Vanves",
    deptCode: "92",
    deptSlug: "hauts-de-seine",
    deptName: "Hauts-de-Seine",
    templateId: "vanves",
    nearbyCities: [
      "Malakoff",
      "Issy-les-Moulineaux",
      "Clamart",
      "Châtillon",
      "Montrouge",
      "Paris 15ᵉ",
    ],
  },
];

export const getCityPageBySlug = (slug) =>
  CITY_PAGES.find((c) => c.slug === slug) || null;

export default CITY_PAGES;
